import CloseIcon from "@mui/icons-material/Close";
import { ControllerProps } from "csi/middleware/common";
import localeProvider from "csi/page/localeProvider";
import { Button, FlexRow, GridRow, IconButton, ModalDialog, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import CareAndCompositionSubtypeMainContent from "./CareAndCompositionSubtypeMainContent";
import { CareAndCompositionSubtypeStore, CareAndCompositionSubtypeStoreContext } from "./CareAndCompositionSubtypeStore";

interface CareAndCompositionSubtypeSaveDialogProps extends Omit<ControllerProps, "store"> {
	store: CareAndCompositionSubtypeStore;
}

const CareAndCompositionSubtypeSaveDialog: FunctionComponent<CareAndCompositionSubtypeSaveDialogProps> = observer(
	function CareAndCompositionSubtypeSaveDialog(props) {
		const {
			onClose,
			store,
		} = props;	
		const careAndCompositionSubtypeStore = store;
		const { 
			disableSaveButton, 
			onClickSaveNew, 
			onSaveWithSaveNew, 
		} = careAndCompositionSubtypeStore;
		return (
			<>
				{careAndCompositionSubtypeStore && (
					<CareAndCompositionSubtypeStoreContext.Provider value={careAndCompositionSubtypeStore}>
						<ModalDialog
							onClose={onClose}
							open
							showDividers
						>
							{{
								buttons: (
									<GridRow justifyContent="flex-end" spacing={2}>
										<Button
											design="secondary"
											disabled={disableSaveButton}
											onClick={onClickSaveNew}
										>{localeProvider.resource("Save_New")}</Button>
										<Button
											design="primary"
											disabled={disableSaveButton}
											onClick={onSaveWithSaveNew}
										>{localeProvider.resource("Save")}</Button>
										<Button design="link" onClick={onClose}>{localeProvider.resource("Cancel")}</Button>
									</GridRow>
								),
								header: (
									<FlexRow 
										alignItems="center"
										justifyContent="space-between"
										paddingX={3}
										paddingY={4}
										width="100%"
									>
										<Text
											bold
											res="NewCareAndCompositionDataSheetType"
											size={16}
										/>
										<IconButton
											onClick={onClose}
											size="small"
										>
											<CloseIcon />
										</IconButton>
									</FlexRow>
								),
								main: (
									<CareAndCompositionSubtypeMainContent />
								),
							}}
						</ModalDialog>
					</CareAndCompositionSubtypeStoreContext.Provider>
				)}
			</>
		);
	},
);

export default CareAndCompositionSubtypeSaveDialog;
